import { Component, ReactNode } from 'react';
import CurrencyInput from 'react-currency-input-field';
import { NavLink, useNavigate, useParams } from 'react-router';
import { toast } from 'react-toastify';
import { AdminApi } from '../admin-api';
import Header from './Header';
import LoadingButton from './LoadingButton';
import PageLoading from './PageLoading';
import Sidebar from './Sidebar';
import SwatchesPicker from './SwatchesPicker';

import 'react-image-crop/dist/ReactCrop.css';
import CropPhoto from './CropPhoto';

export default function PeopleEdit(props: any): ReactNode {
  return (
    <PeopleEditComp navigate={useNavigate()} params={useParams()} {...props} />
  );
}

class PeopleEditComp extends Component {
  constructor(
    readonly props: Readonly<{
      children?: ReactNode;
      navigate?: any;
      currentUser?: any;
      params?: any;
    }>,
  ) {
    super(props);
    this.state = {
      isLoading: true,
      isSubmitting: false,
      data: null,
    };
  }

  state: Readonly<{
    isLoading: boolean;
    isSubmitting: boolean;
    data: {
      name: string;
      email: string;
      id: number;
      price: number;
      comission: number;
      profilePhotoUrl?: string;
      sitePhotoUrl?: string;
      calendarColor?: string;
    } | null;
  }>;

  async componentDidMount(): Promise<void> {
    const _id = this.props.params.id;

    if (_id) {
      const _data = await AdminApi.get(`/users/${_id}`);
      this.setState({
        isLoading: false,
        data: _data,
        uploadedProfile: _data?.profilePhotoUrl,
      });
    } else {
      this.setState({ isLoading: false, data: { name: '', email: '' } });
    }
  }

  async submit() {
    let _result = null;

    this.setState({ isSubmiting: true });

    if (this.state.data?.id) {
      _result = await AdminApi.put(`/users/${this.state.data.id}`, {
        email: this.state.data.email,
        name: this.state.data.name,
        price: this.state.data.price,
        comission: this.state.data.comission,
        calendarColor: this.state.data.calendarColor,
      });
    } else {
      _result = await AdminApi.post('/users', this.state.data);
    }

    this.setState({ isSubmiting: false });

    if (_result) {
      toast.success('Pessoa salva com sucesso!');

      setTimeout(() => {
        this.props.navigate('/people');
      }, 200);
    }
  }

  canSubmit() {
    return this.state.data?.name?.length && this.state.data?.email?.length;
  }

  async removeProfilePhoto() {
    if (!this.state.data?.id) return;

    await AdminApi.delete(`/users/${this.state.data.id}/profile-photo`);

    this.setState({
      data: { ...this.state.data, profilePhotoUrl: null },
    });
  }

  async uploadProfilePhoto(key: string) {
    const _newUrl = await AdminApi.put(
      `/users/${this.state.data?.id}/profile-photo`,
      {
        key: key,
      },
    );

    this.setState({
      data: { ...this.state.data, profilePhotoUrl: _newUrl },
    });

    return _newUrl;
  }

  async removeSitePhoto() {
    if (!this.state.data?.id) return;

    await AdminApi.delete(`/users/${this.state.data.id}/site-photo`);

    this.setState({
      data: { ...this.state.data, sitePhotoUrl: null },
    });
  }

  async uploadSitePhoto(key: string) {
    const _newUrl = await AdminApi.put(
      `/users/${this.state.data?.id}/site-photo`,
      {
        key: key,
      },
    );

    this.setState({
      data: { ...this.state.data, sitePhotoUrl: _newUrl },
    });

    return _newUrl;
  }

  profilePhoto() {
    return (
      <div className="col-md-4">
        <CropPhoto
          className="img-thumbnail profile-photo"
          cardTitle="Foto de perfil"
          cardHelpText="Selecione uma foto de perfil para aparecer no sistema Admin."
          onRemove={() => this.removeProfilePhoto()}
          onUpload={(key: string) => this.uploadProfilePhoto(key)}
          uploaded={this.state.data?.profilePhotoUrl}
          currentUser={this.props.currentUser}
          cropProps={{
            aspect: 1,
            maxWidth: 500,
            maxHeight: 500,
            style: { maxHeight: '700px' },
            circularCrop: true,
          }}
        />
      </div>
    );
  }

  sitePhoto() {
    return (
      <div className="col-md-8">
        <CropPhoto
          className="img-thumbnail site-photo"
          cardTitle="Foto do Site"
          cardHelpText="Selecione uma foto de trabalho que será exibida no site."
          onRemove={() => this.removeSitePhoto()}
          onUpload={(key: string) => this.uploadSitePhoto(key)}
          uploaded={this.state.data?.sitePhotoUrl}
          currentUser={this.props.currentUser}
          cropProps={{
            aspect: 0.7,
            maxWidth: 1000,
            maxHeight: 1000,
            minWidth: 440,
            minHeight: 480,
            style: { maxHeight: '700px' },
          }}
        />
      </div>
    );
  }

  render(): ReactNode {
    return this.state.isLoading ? (
      <PageLoading />
    ) : (
      <div>
        <Header
          navigate={this.props.navigate}
          currentUser={this.props.currentUser}
        ></Header>
        <div className="container-fluid">
          <div className="row">
            <Sidebar
              navigate={this.props.navigate}
              currentUser={this.props.currentUser}
            ></Sidebar>
            <main className="large-calendar ms-sm-auto px-md-4">
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2">
                  {this.state.data?.id
                    ? `Editar ${this.state.data?.name}`
                    : 'Adicionar pessoa'}
                </h1>
              </div>
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/people">Lista de pessoas</NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Edição de pessoa
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Dados básicos</h5>
                  <p className="card-text">
                    Informe os dados básicos do profissional.
                  </p>
                  <form>
                    <div className="mb-3">
                      <label className="form-label">E-mail</label>
                      <input
                        type="email"
                        className="form-control"
                        onChange={(e) =>
                          this.setState({
                            data: { ...this.state.data, email: e.target.value },
                          })
                        }
                        value={this.state.data?.email}
                        aria-describedby="emailHelp"
                      />
                      <div id="emailHelp" className="form-text">
                        Será utilizado para acesso ao sistema.
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Nome</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) =>
                          this.setState({
                            data: { ...this.state.data, name: e.target.value },
                          })
                        }
                        value={this.state.data?.name}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Valor atendimento</label>
                      <CurrencyInput
                        className="form-control"
                        allowNegativeValue={false}
                        value={this.state.data?.price}
                        decimalSeparator=","
                        groupSeparator="."
                        decimalsLimit={2}
                        min={1}
                        onValueChange={(value, name, values) =>
                          this.setState({
                            data: { ...this.state.data, price: values?.float },
                          })
                        }
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        Percentual comissão (1 a 100)
                      </label>
                      <CurrencyInput
                        className="form-control"
                        decimalSeparator=","
                        groupSeparator="."
                        value={this.state.data?.comission}
                        decimalsLimit={2}
                        max={100}
                        min={0}
                        onValueChange={(value, name, values) =>
                          this.setState({
                            data: {
                              ...this.state.data,
                              comission: values?.float,
                            },
                          })
                        }
                      />
                      <div id="emailHelp" className="form-text">
                        Caso a pessoa não passe comissão, deixe 0.
                      </div>
                    </div>

                    <div className="mb-3">
                      <hr />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Cor no calendário</label>
                      <SwatchesPicker
                        color={this.state.data?.calendarColor}
                        presetColors={[
                          '#186C43',
                          '#E35D6A',
                          '#FDCD3A',
                          '#DE5C9D',
                          '#8C68CD',
                          '#8540F5',
                          '#3D8BFD',
                          '#3DD5F3',
                          '#79DFC1',
                          '#FA7E14',
                          '#D63384',
                          '#801F4F',
                          '#59359A',
                          '#F1AEB5',
                          '#C5B3E6',
                          '#EFADCE',
                          '#E9ECEF',
                        ]}
                        onChange={(c: string) =>
                          this.setState({
                            data: { ...this.state.data, calendarColor: c },
                          })
                        }
                      />

                      <div id="colorHelp" className="form-text">
                        Essa cor será utilizada para identificar a pessoa no
                        calendário.
                      </div>
                    </div>

                    <div className="d-grid gap-2">
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={this.state.isSubmitting || !this.canSubmit()}
                        onClick={() => this.submit()}
                      >
                        {this.state.isSubmitting ? (
                          <LoadingButton />
                        ) : (
                          `${this.state.data?.id ? 'Atualizar' : 'Adicionar'} pessoa`
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div className="row mt-3 mb-3">
                {this.profilePhoto()} {this.sitePhoto()}
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}
